import React from 'react';

import SelectList from './SelectList';

const DEFAULT_HOUR_LIST = [
    { label: '09', value: '09' },
    { label: '10', value: '10' },
    { label: '11', value: '11' },
    { label: '12', value: '12' },
    { label: '13', value: '13' },
    { label: '14', value: '14' },
    { label: '15', value: '15' },
    { label: '16', value: '16' },
    { label: '17', value: '17' },
    { label: '18', value: '18' },
    { label: '19', value: '19' },
    { label: '20', value: '20' },
];

const DEFAULT_MINUTE_LIST = [
    { label: '00', value: '00' },
    { label: '10', value: '10' },
    { label: '20', value: '20' },
    { label: '30', value: '30' },
    { label: '40', value: '40' },
    { label: '50', value: '50' },
];

function CampaignDateTimeInput({
    className,
    inputName,
    value,
    minDate,
    maxDate,
    hourList = DEFAULT_HOUR_LIST,
    minuteList = DEFAULT_MINUTE_LIST,
    maxTime,
    maxDateTime,
    onChange,
}) {
    const [date = '', time = '09:00'] = String(value || '').split(' ');
    const [hour = '09', minute = '00'] = time.split(':');

    const [maxDatePart, maxDateTimeTime] = String(maxDateTime || '').split(' ');
    const getApplicableMaxTime = (targetDate) => (
        maxDateTime && targetDate === maxDatePart ? maxDateTimeTime : maxTime
    );
    const applicableMaxTime = getApplicableMaxTime(date);
    const [maxHour, maxMinute] = String(applicableMaxTime || '').split(':');
    const isMaxHour = applicableMaxTime && hour === maxHour;
    const availableMinuteList = isMaxHour
        ? minuteList.filter((item) => Number(item.value) <= Number(maxMinute))
        : minuteList;

    const changeValue = (nextDate = date, nextHour = hour, nextMinute = minute) => {
        const nextApplicableMaxTime = getApplicableMaxTime(nextDate);
        const [nextMaxHour, nextMaxMinute] = String(nextApplicableMaxTime || '').split(':');
        const isOverMaxTime = nextApplicableMaxTime
            && (Number(nextHour) > Number(nextMaxHour)
                || (Number(nextHour) === Number(nextMaxHour) && Number(nextMinute) > Number(nextMaxMinute)));
        const normalizedTime = isOverMaxTime ? nextApplicableMaxTime : `${nextHour}:${nextMinute}`;

        onChange(inputName, `${nextDate} ${normalizedTime}`);
    };

    return (
        <div className={'d-flex flex-column flex-md-row'}>
            <input
                type="date"
                className={className}
                min={minDate}
                max={maxDate}
                value={date}
                onChange={(event) => changeValue(event.target.value)}
            />

            <div className={'d-flex'}>
                <SelectList
                    className="form-select d-inline w-auto"
                    id="hour"
                    value={hour}
                    list={hourList}
                    onChange={(_, nextHour) => changeValue(date, nextHour)}
                    disableDefault={true}
                />
                <span className='mt-1 mx-1'>시</span>
                <SelectList
                    className="form-select d-inline w-auto"
                    id="minute"
                    value={minute}
                    list={availableMinuteList}
                    onChange={(_, nextMinute) => changeValue(date, hour, nextMinute)}
                    disableDefault={true}
                />
                <span className='mt-1 mx-1'>분</span>
            </div>
        </div>
    );
}

export default CampaignDateTimeInput;
